import { ItemInlineComponent } from './item-inline.component';

export default angular
  .module('sfMobile.components.item-inline', [])
  .component('sfItemInline', ItemInlineComponent).name;
